export const ROUTE_PATH_PREFIX = '/ui/app';
